export var ApiKeyScope;
(function (ApiKeyScope) {
    ApiKeyScope["MetricsRead"] = "metrics:read";
    ApiKeyScope["CreativesRead"] = "creatives:read";
})(ApiKeyScope || (ApiKeyScope = {}));
export const API_KEY_SCOPE_LABELS = {
    [ApiKeyScope.MetricsRead]: 'Metrics (Read)',
    [ApiKeyScope.CreativesRead]: 'Creatives (Read)',
};
export const API_KEY_SCOPE_DESCRIPTIONS = {
    [ApiKeyScope.MetricsRead]: 'Read access to business metrics, engagement data, and funnel analytics',
    [ApiKeyScope.CreativesRead]: 'Read access to creatives data for the TakaTV creative feed',
};
export const ALL_API_KEY_SCOPES = Object.values(ApiKeyScope);
//# sourceMappingURL=api-key-scope.const.js.map